<template>
  <base-section
    :id="id"
  >
    <v-container>
      <base-subheading
        align="center"
        :title="item.title"
        class="text-uppercase"
        space="2"
      />
      <v-row
        class="mt-5"
        align="center"
        justify="center"
      >
        <v-carousel :show-arrows="false">
          <v-carousel-item
            v-for="(foto,i) in item.galeria"
            :key="i"
            :src="foto"
          />
        </v-carousel>
      </v-row>

      <v-row
        class="mt-5"
        align="start"
        justify="center"
      >
        <v-col
          cols="12"
          md="9"
        >
          <h3
            class="title font-weight-bold mb-4 text-left"
          >
            DESCRIPCIÓN
          </h3>
          <P
            class="base-body body-1 grey--text text--darken-1 text-left mb-12"
          >
            {{ item.description }}
          </P>

          <v-row
            align="center"
            justify="center"
          >
            <v-col
              cols="6"
              md="3"
            >
              <div
                class="d-inline-block mx-auto"
              >
                <v-progress-circular
                  :value="75"
                  size="88"
                  color="primary"
                  class="mb-4 primary--text"
                >
                  75%
                </v-progress-circular>
                <div
                  class="font-weight-bold text--primary body-2 font-weight-regular mb-0 text-center grey--text"
                >
                  Proyecto
                </div>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="3"
            >
              <div class="d-inline-block mx-auto">
                <v-progress-circular
                  :value="50"
                  size="88"
                  color="primary"
                  class="mb-4 primary--text"
                >
                  50%
                </v-progress-circular>
                <div
                  class="font-weight-bold text--primary body-2 font-weight-regular mb-0 text-center grey--text"
                >
                  Dirección
                </div>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="3"
            >
              <div class="d-inline-block mx-auto">
                <v-progress-circular
                  :value="100"
                  size="88"
                  color="primary"
                  class="mb-4 primary--text"
                >
                  100%
                </v-progress-circular>
                <div
                  class="font-weight-bold text--primary body-2 font-weight-regular mb-0 text-center grey--text"
                >
                  Ejecución
                </div>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="3"
            >
              <div class="d-inline-block mx-auto">
                <v-progress-circular
                  :value="30"
                  size="88"
                  color="primary"
                  class="mb-4 primary--text"
                >
                  30%
                </v-progress-circular>
                <div
                  class="font-weight-bold text--primary body-2 font-weight-regular mb-0 text-center grey--text"
                >
                  Mantenimiento
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <div
            class="mb-12"
          >
            <h3
              class="title font-weight-bold mb-4 text-center"
            >
              VALORACIÓN
            </h3>
            <div
              class="text-center"
            >
              <v-rating
                v-model="item.rating"
                half-increments
              />
            </div>
          </div>

          <div
            class="caption"
          >
            <h3
              class="title font-weight-bold mb-2 text-left"
            >
              DATOS
            </h3>
            <v-divider />
            <div
              class="grey--text text--darken-1"
            >
              <v-row
                class="mx-0 my-3"
                justify="space-between"
              >
                <span
                  class="text-uppercase"
                >
                  Año
                </span>
                <strong>
                  2018
                </strong>
              </v-row>
              <v-divider />
              <v-row
                class="mx-0 my-3"
                justify="space-between"
              >
                <span class="text-uppercase">Duración</span>
                <strong class="text-uppercase">8 MESES</strong>
              </v-row>
              <v-divider />
              <v-row
                class="mx-0 my-3"
                justify="space-between"
              >
                <span class="text-uppercase">Ciudad</span>
                <strong class="text-uppercase">Sevilla</strong>
              </v-row>
              <v-divider />
              <v-row
                class="mx-0 my-3"
                justify="space-between"
              >
                <span class="text-uppercase">Cliente</span>
                <strong class="text-uppercase">Novarquia</strong>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionTrabajosSlug',

    props: {
      id: {
        type: String,
        default: 'trabajo-slug',
      },
    },

    data: () => ({
      // imagen: require('@/assets/about.jpg'),
    }),

    computed: {
      item () {
        return {
          title: 'Planta Solar',
          shortDescription:
            'Una descripción corta del tarbajo realizado. Máximo 150 caracteres.',
          description: `Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sapiente dolorem odit dolor provident nisi neque tenetur, exercitationem ea obcaecati quis? Quidem eligendi doloribus exercitationem quo hic quae, temporibus sit neque!
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sapiente dolorem odit dolor provident nisi neque tenetur, exercitationem ea obcaecati quis? Quidem eligendi doloribus exercitationem quo hic quae, temporibus sit neque!
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sapiente dolorem odit dolor provident nisi neque tenetur, exercitationem ea obcaecati quis? Quidem eligendi doloribus exercitationem quo hic quae, temporibus sit neque!`,
          galeria: [
            require('@/assets/jobs/estacion.jpg'),
            require('@/assets/jobs/clima.jpg'),
            require('@/assets/jobs/contraincendios.jpg'),
            require('@/assets/jobs/cuadro.jpg'),
            require('@/assets/jobs/fonta.jpg'),
            require('@/assets/jobs/galisur.jpg'),
            require('@/assets/jobs/oficina.jpg'),
            require('@/assets/jobs/renault.jpg'),
            require('@/assets/jobs/sabadell.jpg'),
          ],
          rating: 4.5,
        }
      },

      imagenPrincipal () {
        return this.item.galeria[0]
      },
    },
  }
</script>
